export default {
  methods: {
    colorFromSpellingErrorType(checks) {
      const blue = 0;
      const yellow = 1;
      const red = 2;

      const colorOutput = {
        0: '#6FC0FB',
        1: '#FFA01C',
        2: '#D64535',
      };

      let ret = blue;
      checks.forEach((check) => {
        let curRet = 0;
        switch (check.rule.issueType) {
          case 'typographical':
            curRet = yellow;
            break;
          case 'misspelling':
            curRet = red;
            break;
          default:
            curRet = blue;
            break;
        }

        if (curRet > ret) {
          ret = curRet;
        }
      });

      return colorOutput[ret];
    },
  },
};
